<div class="container sticky-top mainnav">
  <nav
    class="navbar navbar-expand-lg navbar-light spaced-border-bottom"
    [class.sticky-top]="isSticky()"
    [style.background-color]="backgroundColor()">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-label="Toggle navigation"
      aria-expanded="false">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav nav-justified mr-auto" style="width: 100%" [ngClass]="getTextAlignmentForDropdown()">
        @for (menu of menuList(); track $index) {
          @if (!menu?.submenus?.length) {
            <li class="nav-item menu-item" [ngClass]="{ active: menu.isActive }">
              @if (!menu?.href) {
                <a class="nav-link" routerLink="{{ menu.routerLinkUrl }}" (click)="onSelectMenu(menu)" anchorExternalUrl
                  ><span class="nav-link-text">{{
                    menu.useTranslation ? (menu.menuName | translate) : menu.menuName
                  }}</span></a
                >
              } @else {
                <a class="nav-link" href="{{ menu.href }}" (click)="onSelectMenu(menu)" anchorExternalUrl
                  ><span class="nav-link-text">{{
                    menu.useTranslation ? (menu.menuName | translate) : menu.menuName
                  }}</span></a
                >
              }
            </li>
          } @else {
            <li dropdown class="dropdown nav-item menu-item" [ngClass]="{ active: menu.isActive }">
              <portal-dropdown-link
                [linkText]="menu.menuName"
                [menu]="menu"
                (menuChange)="onSelectMenu($event)"></portal-dropdown-link>
              <div
                *dropdownMenu
                class="dropdown-menu dropdown-offset"
                [ngClass]="getTextAlignmentForSubmenu()"
                [class.dropdown-right-aligment]="menu.isRightAligned">
                @if (menu.imageSource) {
                  <div [class.float-content-right]="isTextAlignedLeft" [class.float-content-left]="!isTextAlignedLeft">
                    <img
                      [src]="menu.imageSource"
                      class="img-fluid hide-mobile img-margin"
                      [alt]="'GAST-PORTAL-MENU_LIST.IMAGE' | translate" />
                  </div>
                }
                <div [class.float-content-right]="!isTextAlignedLeft" [class.float-content-left]="isTextAlignedLeft">
                  <p class="p-dropdown">{{ menu.menuName }}</p>
                  @for (submenu of menu.submenus; track $index) {
                    @if (!submenu.href) {
                      <a
                        class="dropdown-item"
                        (click)="onSelectSubmenu(submenu)"
                        routerLink="{{ submenu.routerLinkUrl }}"
                        >{{ submenu.useTranslation ? (submenu.visibleText | translate) : submenu.visibleText }}</a
                      >
                    } @else {
                      <a class="dropdown-item" (click)="onSelectSubmenu(submenu)" href="{{ submenu.href }}">{{
                        submenu.useTranslation ? (submenu.visibleText | translate) : submenu.visibleText
                      }}</a>
                    }
                  }
                </div>
              </div>
            </li>
          }
        }
      </ul>
    </div>
  </nav>
</div>
